import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestfulApiService } from '../restful-api.service';

export interface ProjectUpdatePicture {
  uuid: string;
  url: string;
  filename: string;
  type: string;
}

export interface ProjectUpdate {
  projectUpdateUuid: string;
  headline: string;
  modificationDate: number;
  updatedBy: string;
  numberOfDaysSinceLastUpdate: number;
  amountRaisedToDate: number;
  totalProjectBudget: number;
  update: string;
  updatePicture: ProjectUpdatePicture | null;
  updateVideo: any;
  updateThumbnailVideo: any;
  published: boolean;
}

export interface GetProjectUpdatesPayload {
  dealType: string;
  entityUuid: string;
  page: number;
  size: number;
  sortBy: { field: string; order: string };
  draftNeeded: boolean;
}

export interface GetProjectUpdatesResponse {
  response: {
    pageNumber: number;
    totalObjects: number;
    from: number;
    to: number;
    projectUpdates: ProjectUpdate[];
    amountRaisedToDate: number;
    amountRaisedToDateCurrencySymbol: string;
    totalProjectBudget: number;
  };
}

export interface SaveProjectUpdatePayload {
  headline: string;
  projectUuid: string;
  published: boolean;
  amountRaisedToDate: number;
  update: string;
  projectUpdateUuid?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProjectUpdateService {
  constructor(private api: RestfulApiService) {}

  getProjectUpdates(payload: GetProjectUpdatesPayload): Observable<GetProjectUpdatesResponse> {
    return this.api.post('/v1/user-assets/get-updates', payload) as Observable<GetProjectUpdatesResponse>;
  }

  saveProjectUpdate(payload: SaveProjectUpdatePayload): Observable<any> {
    return this.api.post('/v1/project/create-or-publish-update', payload);
  }

  deleteProjectUpdate(projectUpdateUuid: string, languageCode = 'eng'): Observable<any> {
    return this.api.delete(`/v1/project/delete-update/${projectUpdateUuid}?languageCode=${languageCode}`);
  }

  uploadUpdatePicture(projectUuid: string, file: File, secondUuid: string | null = null): Observable<any> {
    const formData = new FormData();
    formData.append('entityUuid', projectUuid);
    formData.append('fileType', 'PROJECT_UPDATE_PICTURE');
    formData.append('secondUuid', secondUuid ?? '');
    formData.append('file', file);
    return this.api.post('/v1/general/upload/file', formData);
  }

  deleteUpdatePicture(projectUpdateUuid: string, fileUuid: string): Observable<any> {
    const params = {
      entityUuid: projectUpdateUuid,
      fileType: 'PROJECT_UPDATE_PICTURE',
      fileUuid
    };
    return this.api.delete('/v1/general/delete/file', params);
  }
}
